module.exports = __webpack_public_path__ + "static/img/testimony (67).7382bc0b.jpg";